import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const SiteFeaturesSection = ({ formData, updateFormData }) => {
  const handleFeatureChange = (feature, checked) => {
    const updatedFeatures = checked
      ? [...formData?.siteFeatures, feature]
      : formData?.siteFeatures?.filter(f => f !== feature);
    updateFormData('siteFeatures', updatedFeatures);
  };

  const features = [
    { id: 'waterfront', label: 'Waterfront Access', description: 'Lake, river, or ocean views', icon: 'Waves' },
    { id: 'petFriendly', label: 'Pet-Friendly', description: 'Dog parks and pet amenities', icon: 'Heart' },
    { id: 'bigRigAccess', label: 'Big Rig Access', description: 'Sites for large RVs (40+ ft)', icon: 'Truck' },
    { id: 'pullThrough', label: 'Pull-Through Sites', description: 'Easy access without backing', icon: 'ArrowRight' },
    { id: 'wifi', label: 'WiFi Internet', description: 'High-speed internet access', icon: 'Wifi' },
    { id: 'laundry', label: 'Laundry Facilities', description: 'On-site washers and dryers', icon: 'Shirt' },
    { id: 'restrooms', label: 'Restroom/Showers', description: 'Clean bathroom facilities', icon: 'Home' },
    { id: 'recreation', label: 'Recreation Area', description: 'Playground, pool, or activities', icon: 'TreePine' },
    { id: 'store', label: 'Camp Store', description: 'Convenience store on-site', icon: 'ShoppingBag' },
    { id: 'security', label: '24/7 Security', description: 'Gated access and monitoring', icon: 'Shield' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
          <Icon name="Star" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-bold text-foreground">Site Features & Amenities</h3>
          <p className="text-sm text-muted-foreground">Select features that will be available at your RV park</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {features?.map((feature) => (
          <div key={feature?.id} className="flex items-start space-x-3 p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg mt-1">
              <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <Checkbox
                label={feature?.label}
                description={feature?.description}
                checked={formData?.siteFeatures?.includes(feature?.id)}
                onChange={(e) => handleFeatureChange(feature?.id, e?.target?.checked)}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-4 bg-muted rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>
            Selected Features: {formData?.siteFeatures?.length} | Premium amenities can increase rates by 15-30%
          </span>
        </div>
      </div>
    </div>
  );
};

export default SiteFeaturesSection;